import { render, staticRenderFns } from "./NotesList.vue?vue&type=template&id=8a20940a&"
import script from "./NotesList.vue?vue&type=script&lang=ts&"
export * from "./NotesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports